import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const ImageResponse = ({ onAnswered }) => {
  const { t } = useTranslation();

  const [pictures, setPictures] = useState([]);
  const [error, setError] = useState("");

  const MAX_FILE_SIZE = 4000000;
  const ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png"];

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files || files.length === 0) return;

    const file = files[0];
    const extension = file.name.split(".").pop().toLowerCase();

    if (!ALLOWED_EXTENSIONS.includes(extension)) {
      setError(
        `Sorry, only ${ALLOWED_EXTENSIONS.join(", ").toUpperCase()} files are allowed.`
      );
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setError(
        `Sorry, only files smaller than ${MAX_FILE_SIZE / 1000000} MB are allowed.`
      );
      return;
    }

    setError("");
    setPictures([file]);
    onAnswered(file);
  };

  return (
    <div style={styles.uploadCard}>
      <label style={styles.uploadButton}>
        {t("upload")}
        <input
          type="file"
          accept={ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(",")}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </label>

      {error && <p style={styles.errorMessage}>{error}</p>}

      {pictures.length > 0 && (
        <div style={styles.previewContainer}>
          <img
            src={URL.createObjectURL(pictures[0])}
            alt="preview"
            style={styles.previewImage}
          />
        </div>
      )}
    </div>
  );
};

const styles = {
  uploadCard: {
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "500px",
    margin: "20px auto",
  },
  uploadButton: {
    display: "inline-block",
    padding: "6px 35px",
    backgroundColor: "#3a3d55",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "400",
    textTransform: "uppercase",
    borderRadius: "50px",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  errorMessage: {
    color: "red",
    fontSize: "14px",
    marginTop: "10px",
  },
  previewContainer: {
    marginTop: "15px",
  },
  previewImage: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  },
};

export default ImageResponse;
